/* 快速计算器 —— QuickCalcPane */

const QC_MANGAN_TBL = {
  mangan:    { ko: { ron: 8000,  ts: [4000, 2000] }, oya: { ron: 12000, ts: [4000, 4000] } },
  haneman:   { ko: { ron: 12000, ts: [6000, 3000] }, oya: { ron: 18000, ts: [6000, 6000] } },
  baiman:    { ko: { ron: 16000, ts: [8000, 4000] }, oya: { ron: 24000, ts: [8000, 8000] } },
  sanbaiman: { ko: { ron: 24000, ts: [12000, 6000] }, oya: { ron: 36000, ts: [12000, 12000] } },
  yakuman:   { ko: { ron: 32000, ts: [16000, 8000] }, oya: { ron: 48000, ts: [16000, 16000] } },
};
const QC_MG_MAP  = { '67': 'haneman', '810': 'baiman', '1112': 'sanbaiman', '13': 'yakuman' };
const QC_MG_NAME = { mangan: '満贯', haneman: '跳満', baiman: '倍満', sanbaiman: '三倍満', yakuman: '役満' };
const QC_HAN_LABELS = {
  '1':'1番','2':'2番','3':'3番','4':'4番','5':'5番',
  '67':'6・7番','810':'8～10番','1112':'11・12番','13':'13番～'
};

const QC_MELD_OPTS = [
  { label: '顺子',  sub: '',    fu: 0  },
  { label: '明刻',  sub: '中张', fu: 2  },
  { label: '明刻',  sub: '幺九', fu: 4  },
  { label: '暗刻',  sub: '中张', fu: 4  },
  { label: '暗刻',  sub: '幺九', fu: 8  },
  { label: '明杠',  sub: '中张', fu: 8  },
  { label: '明杠',  sub: '幺九', fu: 16 },
  { label: '暗杠',  sub: '中张', fu: 16 },
  { label: '暗杠',  sub: '幺九', fu: 32 },
];

const QC_YAKU_TABLE = [
  { mz: '1番', nk: '×',   name: '立直' },
  { mz: '1番', nk: '×',   name: '一发' },
  { mz: '1番', nk: '×',   name: '门清自摸' },
  { mz: '1番', nk: '×',   name: '平和' },
  { mz: '1番', nk: '×',   name: '一杯口' },
  { mz: '1番', nk: '1番', name: '役牌（三元 / 风牌）' },
  { mz: '1番', nk: '1番', name: '断幺九' },
  { mz: '1番', nk: '1番', name: '海底摸月' },
  { mz: '1番', nk: '1番', name: '河底捞鱼' },
  { mz: '1番', nk: '1番', name: '岭上开花' },
  { mz: '1番', nk: '1番', name: '抢杠' },
  { mz: '2番', nk: '×',   name: '双立直' },
  { mz: '2番', nk: '×',   name: '七对子' },
  { mz: '2番', nk: '1番', name: '三色同顺' },
  { mz: '2番', nk: '1番', name: '一气通贯' },
  { mz: '2番', nk: '1番', name: '混全带幺九' },
  { mz: '2番', nk: '2番', name: '三色同刻' },
  { mz: '2番', nk: '2番', name: '三暗刻' },
  { mz: '2番', nk: '2番', name: '对对和' },
  { mz: '2番', nk: '2番', name: '三杠子' },
  { mz: '2番', nk: '2番', name: '小三元' },
  { mz: '2番', nk: '2番', name: '混老头' },
  { mz: '3番', nk: '×',   name: '二杯口' },
  { mz: '3番', nk: '2番', name: '纯全带幺九' },
  { mz: '3番', nk: '2番', name: '混一色' },
  { mz: '6番', nk: '5番', name: '清一色' },
  { mz: '役満', nk: '×',   name: '四暗刻',  ym: true },
  { mz: '役満', nk: '×',   name: '国士无双', ym: true },
  { mz: '役満', nk: '役満', name: '大三元',  ym: true },
  { mz: '役満', nk: '役満', name: '绿一色',  ym: true },
  { mz: '役満', nk: '役満', name: '字一色',  ym: true },
  { mz: '役満', nk: '役満', name: '清老头',  ym: true },
  { mz: '役満', nk: '役満', name: '四杠子',  ym: true },
  { mz: '役満', nk: '役満', name: '小四喜',  ym: true },
  { mz: '役満', nk: '役満', name: '大四喜',  ym: true },
  { mz: '役満', nk: '×',   name: '九莲宝灯', ym: true },
  { mz: '役満', nk: '×',   name: '地和',    ym: true },
  { mz: '役満', nk: '×',   name: '天和',    ym: true },
];

// ─── 计算逻辑 ─────────────────────────────────────────
function qcC100(x) { return Math.ceil(x / 100) * 100; }

function qcBuildMangan(player, winFu, lvl) {
  const row = QC_MANGAN_TBL[lvl][player === 'ko' ? 'ko' : 'oya'];
  const isTsumo = winFu === 2;
  let total, payDetail = '';
  if (!isTsumo) {
    total = row.ron;
  } else if (player === 'ko') {
    total = row.ts[0] + row.ts[1] * 2;
    payDetail = `亲 ${row.ts[0].toLocaleString()} · 子 ${row.ts[1].toLocaleString()} × 2`;
  } else {
    total = row.ts[0] * 3;
    payDetail = `${row.ts[0].toLocaleString()} all`;
  }
  return { total, payDetail, name: QC_MG_NAME[lvl] };
}

function qcCompute(player, winFu, hanKey, effectiveFu) {
  if (!hanKey) return null;
  const mgLvl = QC_MG_MAP[hanKey];
  if (mgLvl) return qcBuildMangan(player, winFu, mgLvl);
  const han = parseInt(hanKey);
  if (han >= 5) return qcBuildMangan(player, winFu, 'mangan');
  // 需要符数
  if (effectiveFu === null) return null;
  if (effectiveFu === 20 && (winFu !== 2 || han < 2)) {
    return { error: '20符仅限平和自摸（需2番以上）' };
  }
  if ((han === 4 && effectiveFu === 30) || (han === 3 && effectiveFu === 60)) {
    return qcBuildMangan(player, winFu, 'mangan');
  }
  const bp = effectiveFu * Math.pow(2, han + 2);
  if (bp >= 2000) return qcBuildMangan(player, winFu, 'mangan');
  const isTsumo = winFu === 2;
  let total, payDetail = '';
  if (player === 'ko') {
    if (!isTsumo) {
      total = qcC100(bp * 4);
    } else {
      const fromDealer = qcC100(bp * 2), fromChild = qcC100(bp);
      total = fromDealer + fromChild * 2;
      payDetail = `亲 ${fromDealer.toLocaleString()} · 子 ${fromChild.toLocaleString()} × 2`;
    }
  } else {
    if (!isTsumo) {
      total = qcC100(bp * 6);
    } else {
      const each = qcC100(bp * 2);
      total = each * 3;
      payDetail = `${each.toLocaleString()} all`;
    }
  }
  return { total, payDetail, fu: effectiveFu, han };
}

// ─── 役参考弹窗 ───────────────────────────────────────
function QCYakuModal({ th, onClose }) {
  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.65)',
      zIndex: 200, display: 'flex', alignItems: 'flex-end',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        width: '100%', maxWidth: 420, margin: '0 auto',
        background: th.panel,
        borderTopLeftRadius: 12, borderTopRightRadius: 12,
        maxHeight: '82vh', display: 'flex', flexDirection: 'column',
        animation: 'slideUp 240ms cubic-bezier(.2,.8,.2,1)',
      }}>
        <div style={{
          flexShrink: 0, padding: '12px 16px',
          background: th.surface, borderBottom: `1px solid ${th.line}`,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          borderTopLeftRadius: 12, borderTopRightRadius: 12,
        }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: th.ink, letterSpacing: '0.2em', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>役　参　考</span>
          <button onClick={onClose} style={{ width: 28, height: 28, border: `1px solid ${th.line}`, background: 'transparent', color: th.ink2, borderRadius: 4, cursor: 'pointer', fontSize: 16 }}>×</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                {['门清', '副露', '役　名'].map((h, i) => (
                  <th key={i} style={{
                    background: th.surface, color: th.ink2,
                    padding: '7px 8px', textAlign: i < 2 ? 'center' : 'left',
                    fontWeight: 600, letterSpacing: '0.04em',
                    borderBottom: `2px solid ${th.line}`,
                    whiteSpace: i < 2 ? 'nowrap' : 'normal',
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {QC_YAKU_TABLE.map((y, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? th.bg : th.surface }}>
                  <td style={{ padding: '6px 8px', textAlign: 'center', borderBottom: `1px solid ${th.line}`, color: y.ym ? th.accent : th.ink2, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', fontSize: y.ym ? 11 : 13, whiteSpace: 'nowrap' }}>{y.mz}</td>
                  <td style={{ padding: '6px 8px', textAlign: 'center', borderBottom: `1px solid ${th.line}`, color: y.ym ? th.accent : th.ink2, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', fontSize: y.ym ? 11 : 13, whiteSpace: 'nowrap' }}>{y.nk}</td>
                  <td style={{ padding: '6px 8px', borderBottom: `1px solid ${th.line}`, color: y.ym ? th.accent : th.ink, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', fontWeight: y.ym ? 600 : 400, width: '100%' }}>{y.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ─── 固定底栏：快速结果 ───────────────────────────────
function QCResultBar({ th, result, player, winFu, hanKey, effectiveFu, showFuArea }) {
  const WIN_LABEL = { 0: '鸣荣', 10: '门清荣', 2: '自摸' };
  const playerLabel = player === 'ko' ? '子家' : '亲家';
  const winLabel = WIN_LABEL[winFu];

  let leftTop = '选择番数 →';
  let leftBot = '';
  if (hanKey) {
    leftTop = `${playerLabel}　${winLabel}`;
    const hanDisp = QC_HAN_LABELS[hanKey] || '';
    leftBot = hanDisp + (showFuArea ? (effectiveFu !== null ? `　${effectiveFu}符` : '　— 符') : '');
  }

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: 420, height: 80,
      display: 'flex',
      background: th.panel, borderTop: `1px solid ${th.line}`,
      boxShadow: '0 -6px 20px rgba(0,0,0,.12)',
      zIndex: 5,
    }}>
      {/* 左：条件 */}
      <div style={{
        width: '40%', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        background: th.surface, borderRight: `1px solid ${th.line}`,
        padding: '0 10px', textAlign: 'center',
      }}>
        <div style={{ fontSize: 11, color: th.ink2, letterSpacing: '0.05em', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>{leftTop}</div>
        {leftBot && <div style={{ fontSize: 13, color: th.ink, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', fontWeight: 500, marginTop: 3 }}>{leftBot}</div>}
      </div>
      {/* 右：点数 */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '0 12px',
      }}>
        {!result ? (
          <div style={{ fontSize: 14, color: th.ink2, letterSpacing: '0.1em', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>—</div>
        ) : result.error ? (
          <div style={{ fontSize: 11, color: th.accent, textAlign: 'center', lineHeight: 1.5 }}>{result.error}</div>
        ) : (
          <>
            {result.name && (
              <div style={{ fontSize: 11, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', marginBottom: 1 }}>{result.name}</div>
            )}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 3 }}>
              <span style={{ fontSize: 26, fontWeight: 600, color: th.ink, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', lineHeight: 1 }}>
                {result.total.toLocaleString()}
              </span>
              <span style={{ fontSize: 12, color: th.ink2 }}>点</span>
            </div>
            {result.payDetail && (
              <div style={{ fontSize: 10, color: th.ink2, marginTop: 2 }}>{result.payDetail}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

// ─── 主组件 ───────────────────────────────────────────
function QuickCalcPane({ th, s }) {
  const { useState, useMemo } = React;

  const [player,       setPlayer]       = useState('ko');
  const [winFu,        setWinFu]        = useState(0);
  const [hanKey,       setHanKey]       = useState(null);
  const [fuMode,       setFuMode]       = useState('manual');
  const [fu,           setFu]           = useState(null);
  const [autoMeldIdxs, setAutoMeldIdxs] = useState([0, 0, 0, 0]);
  const [autoJantai,   setAutoJantai]   = useState(0);
  const [autoMachi,    setAutoMachi]    = useState(0);
  const [showYaku,     setShowYaku]     = useState(false);

  const isMangan   = hanKey && (!!QC_MG_MAP[hanKey] || parseInt(hanKey) >= 5);
  const showFuArea = !!(hanKey && !isMangan);

  const autoFu = useMemo(() => {
    const wb = winFu === 10 ? 10 : winFu === 2 ? 2 : 0;
    const meldSum = autoMeldIdxs.reduce((sum, idx) => sum + QC_MELD_OPTS[idx].fu, 0);
    const raw = 20 + wb + meldSum + autoJantai + autoMachi;
    return Math.ceil(raw / 10) * 10;
  }, [winFu, autoMeldIdxs, autoJantai, autoMachi]);

  const effectiveFu = showFuArea ? (fuMode === 'auto' ? autoFu : fu) : null;

  const result = useMemo(
    () => qcCompute(player, winFu, hanKey, effectiveFu),
    [player, winFu, hanKey, effectiveFu]
  );

  // 按钮样式工厂
  const btn = (active, extra = {}) => ({
    padding: '9px 4px', fontSize: 13, fontWeight: active ? 600 : 400,
    borderRadius: 4,
    border: `1px solid ${active ? th.accent : th.line}`,
    background: active ? th.accent : th.panel,
    color: active ? '#fff' : th.ink,
    cursor: 'pointer', letterSpacing: '0.05em',
    fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', lineHeight: 1.3,
    transition: 'all 120ms',
    ...extra,
  });

  const secLabel = {
    fontSize: 10, color: th.ink2, letterSpacing: '0.3em',
    padding: '12px 16px 6px', display: 'flex', alignItems: 'center', gap: 8,
  };

  return (
    <div style={{ paddingBottom: 90 }}>

      {/* ── 亲 / 子 ── */}
      <div style={secLabel}>
        <span>亲　子</span>
        <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }} />
      </div>
      <div style={{ padding: '0 12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        {[['ko', '子家'], ['oya', '亲家']].map(([k, v]) => (
          <button key={k} onClick={() => setPlayer(k)} style={btn(player === k)}>{v}</button>
        ))}
      </div>

      {/* ── 和牌方式 ── */}
      <div style={secLabel}>
        <span>和牌方式</span>
        <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }} />
      </div>
      <div style={{ padding: '0 12px', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
        {[[0, '鸣牌荣和'], [10, '门清荣和'], [2, '自摸']].map(([k, v]) => (
          <button key={k} onClick={() => setWinFu(k)} style={btn(winFu === k)}>{v}</button>
        ))}
      </div>

      {/* ── 番数 ── */}
      <div style={secLabel}>
        <span>番　数</span>
        <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }} />
      </div>
      <div style={{ padding: '0 12px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
        {Object.entries(QC_HAN_LABELS).map(([k, v]) => (
          <button key={k}
            onClick={() => { setHanKey(k); setFu(null); }}
            style={btn(hanKey === k)}>{v}</button>
        ))}
      </div>

      {/* ── 役参考按钮 ── */}
      <div style={{ padding: '10px 12px 2px' }}>
        <button onClick={() => setShowYaku(true)} style={{
          width: '100%', padding: '9px 0', fontSize: 12, letterSpacing: '0.25em',
          border: `1px solid ${th.line}`, background: th.surface, color: th.ink2,
          borderRadius: 4, cursor: 'pointer', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif',
        }}>役　参　考　▾</button>
      </div>

      {/* ── 符数区（1-4番时显示）── */}
      {showFuArea && (
        <div>
          <div style={secLabel}>
            <span>符　数</span>
            <span style={{ flex: 1, height: 1, background: th.line, opacity: 0.6 }} />
          </div>

          {/* 手动 / 自动推算 切换 */}
          <div style={{ padding: '0 12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
            {[['manual', '手动选择'], ['auto', '自动推算']].map(([k, v]) => (
              <button key={k} onClick={() => setFuMode(k)} style={{
                ...btn(fuMode === k),
                background: fuMode === k ? th.ink : th.surface,
                borderColor: fuMode === k ? th.ink : th.line,
                color: fuMode === k ? th.bg : th.ink2,
              }}>{v}</button>
            ))}
          </div>

          {/* 手动选择符数 */}
          {fuMode === 'manual' && (
            <div style={{ padding: '0 12px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 8 }}>
                {[30, 40, 50, 60, 70, 80, 90, 100, 110].map(v => (
                  <button key={v} onClick={() => setFu(v)} style={btn(fu === v)}>{v}符</button>
                ))}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <button onClick={() => setFu(20)} style={btn(fu === 20)}>20符（平和）</button>
                <button onClick={() => setFu(25)} style={btn(fu === 25)}>25符（七对）</button>
              </div>
            </div>
          )}

          {/* 自动推算：面子 × 4 + 雀头 + 待牌 */}
          {fuMode === 'auto' && (
            <div style={{ padding: '0 12px' }}>
              {[0, 1, 2, 3].map(meldIdx => (
                <div key={meldIdx} style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', marginBottom: 5 }}>面子 {meldIdx + 1}</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                    {QC_MELD_OPTS.map((opt, optIdx) => {
                      const isActive = autoMeldIdxs[meldIdx] === optIdx;
                      return (
                        <button key={optIdx}
                          onClick={() => {
                            const next = [...autoMeldIdxs];
                            next[meldIdx] = optIdx;
                            setAutoMeldIdxs(next);
                          }}
                          style={{
                            ...btn(isActive, { fontSize: 12, padding: '6px 4px', lineHeight: 1.4 }),
                            gridColumn: optIdx === 0 ? '1 / -1' : undefined,
                          }}>
                          {opt.label}
                          {opt.sub && <span style={{ fontSize: 10, opacity: 0.8, marginLeft: 5 }}>{opt.sub}</span>}
                          <span style={{ fontSize: 9, opacity: 0.65, marginLeft: 4 }}>{opt.fu}符</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}

              {/* 雀头 */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', marginBottom: 5 }}>雀头</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {[[0, '非役牌', '0符'], [2, '役牌', '2符']].map(([v, label, sub]) => (
                    <button key={v} onClick={() => setAutoJantai(v)} style={btn(autoJantai === v, { fontSize: 12 })}>
                      {label}<span style={{ fontSize: 9, opacity: 0.7, marginLeft: 4 }}>{sub}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* 待牌形 */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', marginBottom: 5 }}>待牌形</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {[[2, '边/嵌/单骑', '2符'], [0, '两面/双碰', '0符']].map(([v, label, sub]) => (
                    <button key={label} onClick={() => setAutoMachi(v)} style={btn(autoMachi === v, { fontSize: 12 })}>
                      {label}<span style={{ fontSize: 9, opacity: 0.7, marginLeft: 4 }}>{sub}</span>
                    </button>
                  ))}
                </div>
              </div>

              <div style={{ textAlign: 'center', padding: '2px 0 8px', fontSize: 13, color: th.ink2, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>
                自动推算：<strong style={{ color: th.accent }}>{autoFu} 符</strong>
              </div>
            </div>
          )}
        </div>
      )}

      {/* 役参考弹窗 */}
      {showYaku && <QCYakuModal th={th} onClose={() => setShowYaku(false)} />}

      {/* 固定底栏 */}
      <QCResultBar
        th={th} result={result}
        player={player} winFu={winFu} hanKey={hanKey}
        effectiveFu={effectiveFu} showFuArea={showFuArea}
      />
    </div>
  );
}

window.QuickCalcPane = QuickCalcPane;
